module.exports = __webpack_public_path__ + "static/media/AdminAvtar.4d596485.svg";